<!--面板组件-->

<template>
  <div>
    <el-form :model="formData" ref="formData">
      <div v-for="(domain, index) in formData.onlineStoreList" :key="domain.key" >
        <div class="header">
          <div class="box_title">Online Store {{ index + 1 }}</div>
          <div
            class="box_remove"
            v-show="formData.onlineStoreList.length !== 1"
            @click="doRemove(index)"
          >
            Remove
          </div>
        </div>
        <div class="input_area">
          <el-form-item
            class="bbb"
            :label="'Marketplace or Social Media'"
            :prop="'onlineStoreList.' + index + '.socialMedia'"
            :rules="{
              required: true,
              message: 'Select website',
              trigger: 'change',
            }"
          >
            <el-select
              v-model="domain.socialMedia"
              placeholder="Select website"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            :label="'Profile Name or URL'"
            :prop="'onlineStoreList.' + index + '.url'"
            class="aaa"
            :rules="[{
              required: true,
              message: 'Enter Profile Name or URL',
              trigger: ['blur','change'],
            },{
              pattern: /[^\u4E00-\u9FA5]$/g,
              message: 'Profile Name or URL is error',
              trigger: ['blur','change'],
            },{
              pattern: /^[^ ]+$/,
              message: 'Please do not enter spaces',
              trigger: ['blur','change'],
            }]"
          >
            <el-input
              v-model="domain.url"
              placeholder="Profile Name or URL"
              maxlength="128"
              clearable
            ></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <div class="box_add">
      <div
        class="addContent"
        @click="doAdd()"
        v-show="formData.onlineStoreList.length !== 5"
      >
        + Add Another Online Store
      </div>
    </div>
  </div>
</template>


<script>
// import API from "@/api";

export default {
  name: "OnlineStore",
  components: {},
  data() {
    return {
      formData: {
        onlineStoreList: [{ socialMedia: "", url: "" }],
      },
      options: [
        {
          value: "Facebook",
          label: "Facebook",
        },
        {
          value: "Instagram",
          label: "Instagram",
        },
        {
          value: "Lazada",
          label: "Lazada",
        },
        {
          value: "Shopee",
          label: "Shopee",
        },
        {
          value: "Carousell",
          label: "Carousell",
        },
        {
          value: "Website",
          label: "Website",
        },
        {
          value: "Others",
          label: "Others",
        },
      ],
    };
  },
  methods: {
    doRemove(index) {
      if (this.formData.onlineStoreList.length > 1) {
        this.formData.onlineStoreList.splice(index, 1);
      }
    },
    doAdd() {
      if (this.formData.onlineStoreList.length < 5) {
        this.formData.onlineStoreList.push({
          socialMedia: "",
          url: "",
        });
      }
    },
    doProcess(val){
      this.formData = Object.assign({}, val);
    },
    updateDataForm(val){
      this.formData.onlineStoreList = val.onlineStoreList
    },
  },
  // props: ["baseData"],
};
</script>

<style lang="scss" scoped>
.header {
  width: 766px;
  font-family: Nunito;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  .box_title {
    color: #004ea8;
    font-family: Nunito-bold;
    margin-bottom: 10px;
  }
  .box_remove {
    color: #0072d8;
    cursor: pointer;
  }
}
.box_add {
  display: flex;
  flex-direction: row-reverse;
  .addContent {
    color: #0072d8;
    text-decoration: underline;
    cursor: pointer;
  }
}
.input_area {
  // display: flex;
  // flex-wrap: wrap;
  // justify-content: space-between;
  overflow: hidden;
  & > div {
    float: left;
  }
  .bbb {
    margin-right: 4%;
  }
}
</style>
